import type { SearchResultItem, SupportSearchResults } from "@core/features/support";
import { Type } from "@themes/pollinator/ui/Type";
import { SupportSearchFormResultItem } from "./SupportSearchFormResultItem";

export type Props = {
  query: string;
  results: SupportSearchResults;
  onResultClick: (item: SearchResultItem) => void;
};

export function SupportSearchFormResults({
  onResultClick,
  query,
  results,
}: Props) {
  return (
    <div className="max-h-[60vh] overflow-y-auto flex flex-col gap-4 pb-4 -mx-1 px-1">
      {Object.entries(results).map(([categoryName, items]) => (
        <SupportSearchFormResultItem
          key={categoryName}
          categoryName={categoryName}
          items={items}
          onItemClick={onResultClick}
        />
      ))}
      {query && Object.keys(results).length === 0 && (
        <Type variant="body2" className="text-center text-primary-700 py-8">
          No results found for "{query}"
        </Type>
      )}
    </div>
  );
}

export default SupportSearchFormResults;

